import { ClipboardList } from "lucide-react";
import { ENC } from "@/constants/testIds";

export default function WhatToOrderPanel() {
  return (
    <div data-testid={ENC.screenWhatToOrder} className="space-y-3">
      <div
        data-testid={ENC.screenOrdersWorkspace}
        className="emr-encdetail__orders"
      >
        <div className="emr-encdetail__orders-icon">
          <ClipboardList className="h-5 w-5" />
        </div>
        <h2>Orders</h2>
        <p className="emr-encdetail__muted">
          Reserved for order entry. Medications, labs, imaging, referrals, and procedures will
          attach here. Orders are not implemented yet.
        </p>
      </div>
    </div>
  );
}
